import { V_FORM_ENUM, extendsSchema } from '@/CommonDP/VForm/utils';
import Dept from './index.vue';
import SingleDept from './single.vue';
export const DEPT_ENUM = {
  user: '{user}',
  dept: '{dept}',
  role: '{role}',
  sysRole: 1,
  specRole: 3,
  prjRole: 4,
  all: '{all}',
  cur_dept: '{currentDept}',
  cur_main: '{currentMainDept}'
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-dept',
  icon: 'tree',
  label: '多部门选择',
  formItemFlag: true,
  component: Dept,
  props() {
    const props = {
      defaultDept: () => import(/* webpackChunk:"xxxxx" */ './defaultSetting.vue')
    };
    return props;
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onValidate: ['rule', 'value', 'callback']
    };
  },
  getSFC: () => {
    return '<div></div>';
  },
  zh: {},
  options: {
    name: '',
    defaultDeptType: DEPT_ENUM.all,
    defaultDept: [],
    label: '部门列表',
    requiredHint: ' ',
    labelWrap: false, // 自动换行
    labelHidden: false,
    labelWidth: '',
    columnWidth: '200px',
    required: false,
    position: '',
    customClass: '',
    disabled: false,
    labelAlign: '',
    onMounted: '',
    max: 100,
    onValidate: '',
    // ID 关联赋值
    mapDeptIdsTo: '',
    // deptName 关联赋值
    mapDeptNamesTo: '',
    mapFullNamesTo: ''
  },
  setDesign: { deptKeys: (item) => (item.options.name) }
};
export const single = extendsSchema({
  type: 'jy-single-dept',
  icon: 'tree',
  label: '单部门选择',
  component: SingleDept,
  options: {
    label: '部门',
    single: true,
    defaultDept: []
  }
}, schema, (schema) => {
  delete schema.setDesign;
  delete schema.options.max;
});
